import { useResources } from "../../utils/hooks/resources/useResources";
import { useSectors } from "../../utils/hooks/sectors/useSectors";
import { useServices } from "../../utils/hooks/services/useServices";
import { useProfiles } from "../../utils/hooks/profile/useProfiles";
import { useAllIntegrations } from "../../utils/hooks/integrations/useIntegrations";
import { getCountryNameForISO2 } from "../../utils/country.utils";
import { getNameForLanguage } from "../../utils/translations.util";
import { useMetaCampaigns } from "../../utils/hooks/meta/useMetaCampaigns";
import { useResourceCategories } from "../../utils/hooks/resources/useAllResourceCategories";
import { useServiceCategories } from "../../utils/hooks/services/useAllServiceCategories";
import { useUsers } from "../../utils/hooks/users/useUsers";
import { formatProfileListName } from "../../utils/profile.util";
var userName = function (firstName, lastName, email, id) { return ([firstName, lastName].filter(Boolean).join(" ") || email || id || "-"); };
export var useIdTypeValues = function (idType, ids) {
    var resources = useResources(idType === "resource" ? ids || [] : []);
    var sectors = useSectors(idType === "sector" ? ids || [] : []);
    var services = useServices(idType === "service" ? ids || [] : []);
    var profiles = useProfiles(idType === "profile" ? ids || [] : []);
    var allIntegrations = useAllIntegrations();
    var metaCampaigns = useMetaCampaigns(idType === "campaign" ? ids || [] : []);
    var resourceCategories = useResourceCategories(idType === "category" ? ids || [] : []);
    var serviceCategories = useServiceCategories(idType === "service_category" ? ids || [] : []);
    var users = useUsers(idType === "user" ? ids || [] : []).data || [];
    switch (idType) {
        case "resource":
            return resources.map(function (r) { return ({ id: r.id, name: r.name }); });
        case "category":
            return resourceCategories.map(function (rc) { return ({ id: rc.id, name: rc.name }); });
        case "service_category":
            return serviceCategories.map(function (rc) { return ({ id: rc.id, name: rc.name }); });
        case "sector":
            return sectors.map(function (s) { return ({ id: s.id, name: s.name }); });
        case "service":
            return services.map(function (s) { return ({ id: s.id, name: s.name }); });
        case "profile":
            return profiles.map(function (p) { return ({ id: p.id, name: formatProfileListName(p) }); });
        case "user":
            return users
                .filter(function (access) { var _a; return !!((_a = access.user) === null || _a === void 0 ? void 0 : _a.id); })
                .map(function (access) {
                var _a, _b, _c, _d;
                return ({
                    id: access.user.id,
                    name: userName((_a = access.user) === null || _a === void 0 ? void 0 : _a.firstName, (_b = access.user) === null || _b === void 0 ? void 0 : _b.lastName, (_c = access.user) === null || _c === void 0 ? void 0 : _c.email, (_d = access.user) === null || _d === void 0 ? void 0 : _d.id)
                });
            });
        case "integration_config":
            var selectedIntegrations = allIntegrations.filter(function (integration) { return ids === null || ids === void 0 ? void 0 : ids.includes(integration.id); });
            return selectedIntegrations.map(function (i) { return ({ id: i.id, name: i.fullName }); });
        case "country_code_iso_3166_alpha_2":
            return (ids === null || ids === void 0 ? void 0 : ids.map(function (id) { return ({ id: id, name: getCountryNameForISO2(id) }); })) || [];
        case "language_code_iso_639_1":
            return (ids === null || ids === void 0 ? void 0 : ids.map(function (id) { return ({ id: id, name: getNameForLanguage(id) }); })) || [];
        case "campaign":
            return metaCampaigns === null || metaCampaigns === void 0 ? void 0 : metaCampaigns.map(function (s) { return ({ id: s.id, name: s.name }); });
        default:
            return [];
    }
};
